export default "__VITE_ASSET__H2Lr5O3M__"